import React, { useState } from 'react';
import Notification from '../components/ui/Notification';
import UploadFileCard from '../features/upload/components/UploadFileCard';
import SessionDetailsCard from '../features/upload/components/SessionDetailsCard';
import TranscriptionCard from '../features/upload/components/TranscriptionCard';
import { useUploadedFile } from '../features/upload/hooks/useUploadedFile';
import { useCreateSessionForm } from '../features/upload/hooks/useCreateSessionForm';
import '../features/upload/styles/upload.css';

export default function UploadPage() {
  const [notification, setNotification] = useState(null);
  const notifyError = (title, message) => setNotification({ type: 'error', title, message });
  const upload = useUploadedFile(notifyError);
  const form = useCreateSessionForm(upload.uploadId, notifyError);

  return (
    <div className="upload-page">
      <form className="upload-content" onSubmit={form.submit}>
        <header className="upload-page-head">
          <h1>Upload</h1>
          <p>Add an audio or video recording. It becomes a session you can transcribe and report on.</p>
        </header>

        <UploadFileCard upload={upload} />
        <SessionDetailsCard form={form} />
        <TranscriptionCard form={form} />

        <div className="upload-actions">
          {!upload.uploadId && <span>{upload.uploading ? 'Waiting for the upload to finish…' : 'Add a file to continue'}</span>}
          <button type="submit" className="upload-btn upload-btn-primary" disabled={!form.canSubmit}>
            {form.submitting ? 'Creating…' : 'Create session'}
          </button>
        </div>
      </form>

      {notification && (
        <Notification {...notification} onClose={() => setNotification(null)} duration={5000} />
      )}
    </div>
  );
}
